export default {
  'SAVE_ADDRESS' (state, payload) {
    state.company = payload
    window.localStorage.setItem('address', JSON.stringify(state.address))
  },
  'CHANGE_ADDRESSES' (state, payload) {
    state.items = [...state.items, ...JSON.parse(JSON.stringify(payload))]
  },
  'CLEAR_ADDRESSES' (state) {
    state.items = []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses/mutations.js